import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { timer } from 'rxjs';
import {
  PushToLiveConfirmationComponent,
  PushToLiveOptions,
} from '../push-to-live-confirmation/push-to-live-confirmation.component';
import { PushLiveOptions } from '../../../../core/staging';

@Component({
  selector: 'app-push-to-live-card',
  templateUrl: './push-to-live.component.html',
  styleUrls: ['./push-to-live.component.scss'],
  standalone: false,
})
export class PushToLiveComponent {
  @Output() pushLiveRequest: EventEmitter<PushLiveOptions> = new EventEmitter<PushLiveOptions>();
  disabledButton: boolean;

  constructor(private dialog: MatDialog) {}

  pushToLive(): void {
    this.disabledButton = true;
    this.dialog
      .open(PushToLiveConfirmationComponent, {
        disableClose: false,
        hasBackdrop: true,
      })
      .afterClosed()
      .subscribe((options: PushToLiveOptions) => {
        if (!!options && options.pushLive) {
          this.pushLiveRequest.emit(new PushLiveOptions(options.siteComponents, options.preserve));
          timer(10000).subscribe(() => (this.disabledButton = false));
        } else {
          this.disabledButton = false;
        }
      });
  }
}
